import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-form-error',
  templateUrl: './message-form-error.component.html',
  styleUrls: ['./message-form-error.component.scss']
})
export class MessageFormErrorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
